import { render } from "./HomePage.vue?vue&type=template&id=5d67a705&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=ts"
export * from "./HomePage.vue?vue&type=script&lang=ts"

import "./HomePage.vue?vue&type=style&index=0&id=5d67a705&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5d67a705"

export default script